<template>
  <div class="page greyBg">
    <!--顶部-->
		<pageTitle title='提示' />

		<div class='countdown whiteBg'   >
			<img src="../../../static/hotel/打钩.png"/>
			<div class="right">
				<div class="title">预订成功，待支付</div>
				<!--<div>如未完成预付，您的订单将保留至{{holdTime}}</div>-->
			</div>
		</div>
		<!--订单详情-->
		<div class="orderMsg whiteBg">
			订单号：<span>{{ g_PayOrder.OrderId }}</span><br />
			总&nbsp;&nbsp;价：<span>￥&nbsp;{{ g_PayOrder.Money | fomatFloat2}}</span>
		</div>
		<!--加载图-->
		<div v-if="IsLoading" style=" width:100% " align="center">
      <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto" v-show="  IsLoading  " />
    </div>
		<!--主要内容-->
		<div class="main whiteBg" v-if='!IsLoading '>
			<!--钱包信息-->
			<div class="wallet">
				<div class='title'>我的钱包</div>
				<div class='detail'>
					<span>K币</span><span class="amount">{{g_walletInfo.KCoin}}</span>
					<span>储值卡</span><span class="amount">{{g_walletInfo.StoreCardMoney}}元</span>
				</div>
			</div>
			<!--支付方式-->
			<div class="payType">
				<div class="title" style="float:left">
					支付方式
				</div>
				<div class="title" style="float:right  ;  font-size:0.22rem ; color:#999999 ;padding-top:0.08rem ">
          <img src="../../../static/payOrder/tick.png"  style="height:0.2rem ; margin-bottom:-0.02rem ; padding-right:0.06rem"   />
					全额可退，优先选房，迅捷入住
				</div>
        <mu-list style="font-size:0.3rem">
					<mu-divider />
          <mu-list-item v-if="loginState" v-on:click="goPay(1)">
            <img src="../../../static/order/SmallStore.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
            <span class='title'>储值卡支付
              <nobr class="Orange" style="  "> 充1000送1000K币 </nobr>
            </span>
            <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
          </mu-list-item>
          <mu-divider />
          <mu-list-item v-on:click="goPay(2)" v-if="loginState">
            <img src="../../../static/order/SmallUnionPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
            <span class='title'>银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
          </mu-list-item>
          <mu-list-item v-on:click="goPay(5)" v-else>
            <img src="../../../static/order/SmallUnionPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
            <span class='title'>银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
          </mu-list-item>
          <mu-divider />
          <mu-list-item v-on:click="goPay(3)" v-bind:style="{display:allowAlipay}">
            <img src="../../../static/order/SmallAlipay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
            <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
            <span class='title'>支付宝支付</span>
          </mu-list-item>
          <mu-divider v-bind:style="{display:allowAlipay}" />
          <mu-list-item v-on:click="goPay(6)" v-bind:style="{display:allowWepay}">
              <img src="../../../static/order/wepay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
              <span class='title'>微信支付</span>
          </mu-list-item>
          <mu-divider v-bind:style="{display:allowWepay}" />
          
          <mu-list-item v-on:click="goPay(7)" v-if="loginState" >
              <img src="../../../static/order/SmallKB.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
              <mu-icon slot="right" value="keyboard_arrow_right" color='#efefef' />
              <span class='title'>K币支付</span>
          </mu-list-item>



          <!--<mu-divider v-bind:style="{display:allowWepay}"/>
          <mu-list-item v-on:click="goPay(4)">
            <img src="../../../static/order/SmallOtherPay.png" style="width:0.6rem" backgroundColor="transparent" slot="left" />
            <mu-icon slot="right" color='#efefef' value="keyboard_arrow_right" />
            <span class='title'>他人代付</span>
          </mu-list-item>-->
					<mu-divider />
        </mu-list>
			</div>
		</div>


    <pop :display='popDisplay' @closeHandler='closePop' @okHandler='closeYES' title='温馨提示' :msg='popMsg' :onlyOk='popOnlyOk'/> 


    <!--弹出框-->
    <mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline" />

    <mu-dialog :open="dialog" @close="close">
      <div style='color:#666666;text-align:center;'>抱歉，您尚未开通储值卡！</div>
      <mu-flat-button slot="actions" @click="goOpenValue" primary label="去开通"/>
      <mu-flat-button slot="actions" primary @click="close" label="取消"/>
    </mu-dialog>
  </div>
</template>


<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
import pageTitle from '../../components/pageTitle'
import orderHelper from '../../utils/order'
import pop from '../../components/pop'


export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder','g_walletInfo'
    ])
  },
  activated() {

    this.closePop()

    this.allowWepay=typeof WeixinJSBridge == "undefined"?'none':'block';
    this.allowAlipay=typeof WeixinJSBridge == "undefined"?'block':'none'
    this.IsLoading = false;

    this.QuickPay = 0;

    this.valueOpen = false
    if(this.g_walletInfo.KCoin == ''){
      this.GetMyWallet()
    }

    this.checkValueCard()
    //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo.Card_no ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {
      if (res.Result) {
        this.loginState = true
      }
      else {
        // this.$http.post(api.LogOff()).then((res) => { });
        // this.$store.commit('CLEARUSER');
        this.loginState = false;

        this.showToast('未登录');

      }
    });
    // 非会员 ， 半小时内支付，会员，休闲房，活动房，半小时内支付 。    会员 非活动房 常规支付
  },
  deactivated(){
    //离开页面清除计时器
	  clearInterval(this.timer)
  },
  data() {
    return {

      // 弹出标签 选择是否
      popDisplay: false,
      popMsg:'',
      popOnlyOk:false,


      IsLoading: true,

      loginState: false,

      dialog: false,

      QuickPay: 0,

      // 储值卡开通状态
      valueOpen:false,

      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否
			dialog: false,
			//计时器
			timer:'',
			//倒计时分钟
			downMinutes:0,
			//倒计时秒数
			downSeconds:0,
			holdTime:'',
      allowWepay:typeof WeixinJSBridge == "undefined"?'none':'block',
      allowAlipay:typeof WeixinJSBridge == "undefined"?'block':'none'
    }
  },
  methods: {
    ...mapMutations([
      'setG_PayOrder','setG_walletInfo'
    ]),
    //开通储值卡
    goOpenValue(){
      this.close()
      this.$router.push({ path: '/wallet/openValueCard' })
		},
		//倒计时
		downTime(){
			if(this.seconds > 0){
				this.seconds -= 1
				this.downMinutes = Math.floor(this.seconds/60)
				this.downSeconds = this.seconds - this.downMinutes*60
			}
		},
		

    
    //跳转登录页面
    goLogin(){
      var that = this;
      setTimeout(function() {
        that.$router.push({ path: "/user/Login" })
      }, 2000);
    },
    //检查储值卡是否开通，开通跳转否则弹出对话框
    checkValueCard(){
      if(typeof this.g_UserInfo.HasOpenStoreCard === "undefined"){
        this.showToast('您的用户信息已过期，请重新登录！');
        //清空信息缓存
        this.$store.commit('CLEARUSER');
        //跳转登录
        this.goLogin();
        return;
      }
      else{
        this.valueOpen = this.g_UserInfo.HasOpenStoreCard
      }
    } ,    

    goPay(val) {

      // 早餐券哪来的银联券 。。。。这块不用担心
      if (val != 2) {
        // if (this.g_PayOrder.UsingUnionCash == undefined) {
        //   console.log(this.g_PayOrder)
        //   this.TellUser = "正在获取信息"
        //   this.showToast();
        //   return
        // }
        if (this.g_PayOrder.UsingUnionCash) {
          this.TellUser = "需要用银联支付"
          this.showToast();
          return
        }
      }

      var Order = this.g_PayOrder;

      if (val == 1) {
        if(!this.valueOpen){
          this.open()
          return
        }
        Order.PayType = "储值卡支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByStoredValueCard?orderType=2' });
      }
      else if (val == 2) {
        Order.PayFor = "PayMent";

        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);

        this.$router.push({ path: '/order/PayByUnion/ChooseCard?orderType=2' });

      }
      else if (val == 3) {
        Order.PayType = "支付宝支付";
        this.setG_PayOrder(Order);
        // this.$router.push({ path: '/PayMent/AliPay?parentNo='+  this.g_PayOrder.OrderId  +'&orderType=1' });

        window.location.href = '/apis/PayMent/PayByAlipay?parentNo=' + this.g_PayOrder.OrderId + '&orderType=2';

      }
      else if (val == 4) {
        Order.PayType = "他人支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByOther?orderType=2' });
      }
      // 未登录用户点击，不跳入选卡页面，直接去输入卡号
      else if (val == 5) {
        Order.PayFor = "PayMent";
        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: '/order/PayByUnion/BeforeBind?orderType=2' });
      }
      else if(val==6){
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/apis/WeChat/GetCodeReturn&response_type=code&scope=snsapi_base&state="+this.g_PayOrder.OrderId+"_2_"+this.g_PayOrder.Money+"_I998#wechat_redirect";
      }
      else if (val == 7) {
        this.openPop('是否使用K币购买早餐券？')
      }
    },


    goback() {
      javascript: history.go(-1);
    },



    closeYES() {
      //  选项关闭
      this.closePop()
      var params = new this.URLSearchParam();
      params.append('breakfastResvNo', this.g_PayOrder.OrderId);

      this.$http.post(api.GreenCoinExchangeBreakfastTicket(), params.toParam()).then((res) => {
        
        var Order = this.g_PayOrder;
        Order.PayType = "K币支付";
        this.setG_PayOrder(Order);
        
        if (res.Result) {
          this.TellUser = res.Data.Msg
          this.showToast();

          this.toastTimer1 = setTimeout(() => {
            this.$router.push({
              path: '/order/PayIsOk?result=true&money=' + this.g_PayOrder.Money + '&parentNo=' + this.g_PayOrder.OrderId
              + '&paytype=K币支付&payDate=' + Date.prototype.NowDate()+'&orderType=2'
            });
          }, 1800);

        }
        else {
          this.TellUser = res.Message
          this.showToast();
        }
      })
    },
    closeNO() {
      //  拒绝取消订单
      this.closePop()
    },
    // END 弹出标签 选择是否








    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    GetMyWallet () {
      this.$http.post(api.GetMyWallet()).then((res) => {
        if(res.Result){
          this.setG_walletInfo(res.Data)
        }
      })
    },

    closePop(){
      this.popDisplay = false
    },
    openPop(msg,onlyOk){
      //是否仅仅显示确定按钮
      if(onlyOk){
        this.popOnlyOk = onlyOk
      }
      else{
        this.popOnlyOk = false
      }
      if(msg){
        this.popMsg = msg  
      }
      this.popDisplay = true
    },
  },
	components:{
		pageTitle, pop
	}
}
</script>




// paper模块
<style lang="less" scoped>
	@import "../../assets/theme.less";
	.page{
		height: auto;
		overflow: hidden;
	}
	.countdown{
		display: flex;
		padding: 0.2rem 0.3rem;
		color: #666666;
		font-size:0.22rem;
		border-bottom: 1px solid #eeeeee;
		img{
			width:0.6rem;
			height: 0.6rem;
			margin: auto 1em auto 0;
		}
		.right{
			margin: auto 0;
			.title{
				color: @primaryColor;
				font-size:0.32rem;
			}
		}
	}
	.orderMsg{
		font-size:0.26rem;
		padding: 0.2rem;
		line-height: 2em;
		span{
			color: #333333;
		}
	}
	.main{
		.mu-list{
			padding: 0;
			.title{
				color: #333333;
			}
		}
		margin-top:0.2rem;
		padding:0.2rem 0.2rem 0 0.2rem;
		.wallet{
			display: flex;
			justify-content:space-between;
			background-color: #fcf8f5;
			border-radius: 4px;
			border:1px solid #f4e9e2;
			font-size:0.26rem;
			padding: 0.2rem;
			.title{
				color: #333333;
			}
			.amount{
				color: @darkOrange;
				font-size:0.3rem;
				margin: 0 0.2rem 0 0.1rem;
			}
		}
		.payType{
			>.title{
				color: #666666;
				font-size: 0.32rem;
				margin: 0.3rem;
			}
		}
	}
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// breakfastPayType.vue?0cbe868f